import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $SectionHeader = styled.div`
  padding: ${spacing('lg')} ${spacing('md')};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  background-color: ${({ theme }) => theme.colors.lightGrey};
  font-weight: ${fontWeight('bold')};
  ${fontStyle('lg')};

  grid-column: 1 / -1;

  &::first-letter {
    text-transform: capitalize;
  }
`;

export const $Cell = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const $CompareLineLabel = styled.div`
  display: flex;
  gap: ${spacing('xs')};

  & > div:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
